/**
 * Управление показом лоадера
 * @method
 * @private
 */

export default (sourceNode, parentNode, className) => {
  if (!sourceNode) { return; }

  const ajaxProductNode = sourceNode.closest(parentNode);

  if (ajaxProductNode) {
    ajaxProductNode.classList.toggle(className);
  }
};
